import {
  ApButtonGroup,
  ApButtonMain,
  ApIcon,
  ApModal,
} from '@alixpartners/ui-components';
import { ApButtonCasual } from 'components/UIComponents/Buttons';

import { DivHtmlText } from '../../../../../components/DivHtmlText/DivHtmlText';
import './SettlementsTemplateRestoreConfirm.css';

interface Props {
  title: string;
  warning: string;
  subject: string;
  template: string;
  onConfirm: (confirmed: boolean) => void;
}

export const SettlementsTemplateRestoreConfirm = ({
  title,
  warning,
  subject,
  template,
  onConfirm,
}: Props) => {
  const handleConfirmClick = () => onConfirm(true);
  const handleCancelClick = () => onConfirm(false);

  return (
    <ApModal
      className="settlements-template-restore-confirm"
      isDismissible={false}
      isFluid={true}
      isOpen={true}
      zIndex={998}
      hasClosed={handleCancelClick}
      footer={() => (
        <ApButtonGroup justifyContent="space-between">
          <ApButtonCasual onClick={handleCancelClick}>Cancel</ApButtonCasual>
          <ApButtonMain onClick={handleConfirmClick}>
            Restore default template
          </ApButtonMain>
        </ApButtonGroup>
      )}
    >
      <h3 className="settlements-template-restore-confirm__header">{title}</h3>
      <div className="settlements-template-restore-confirm__warning">
        <ApIcon iconName="error" iconColor="red" />
        <span>{warning}</span>
      </div>
      <SettlementsTemplateRestorePreview subject={subject} template={template} />
    </ApModal>
  );
};

const SettlementsTemplateRestorePreview = (props: {
  subject: string;
  template: string;
}) => {
  const { subject, template } = props;

  return (
    <div className="settlements-template-restore-preview">
      <div className="settlements-template-restore-preview__title">
        Default Email Template Preview
      </div>
      <div className="settlements-template-restore-preview__body">
        <div className="settlements-template-restore-preview__subject">
          <div className="settlements-template-restore-preview__name">Subject: </div>
          <div>{subject}</div>
        </div>
        <div className="settlements-template-restore-confirm__message">
          <div className="settlements-template-restore-preview__name">Message:</div>
          <div className="settlements-template-restore-confirm__message-text thin-scrollbar">
            <DivHtmlText html={template} />
          </div>
        </div>
      </div>
    </div>
  );
};
